import { useState } from 'react';
import { Menu, X } from 'lucide-react';

interface NavbarProps {
  viewMode: 'public' | 'admin';
  onViewModeChange: (mode: 'public' | 'admin') => void;
}

export function Navbar({ viewMode, onViewModeChange }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-card border-b border-border sticky top-0 z-50 backdrop-blur-lg bg-card/90">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
              <span className="text-primary-foreground font-bold text-xl">P</span>
            </div>
            <span className="font-bold text-xl text-primary">Planisware99</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <a
              href="#"
              className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">

              Solutions
            </a>
            <a
              href="#"
              className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">

              Customers
            </a>
            <a
              href="#"
              className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">

              Resources
            </a>
            <a
              href="#"
              className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">

              Company
            </a>
          </div>

          <div className="flex items-center gap-4">
            <button
              onClick={() => onViewModeChange(viewMode === 'admin' ? 'public' : 'admin')}
              className="hidden md:block bg-secondary text-secondary-foreground px-4 py-2 rounded-lg font-medium text-sm hover:opacity-90 transition-opacity">

              {viewMode === 'admin' ? 'View Public' : 'Admin Panel'}
            </button>
            <button className="bg-accent text-accent-foreground px-6 py-2.5 rounded-lg font-medium text-sm hover:opacity-90 transition-opacity">
              Request Demo
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-foreground">

              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen &&
        <div className="md:hidden py-4 border-t border-border">
            <div className="flex flex-col gap-4">
              <a
              href="#"
              className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">

                Solutions
              </a>
              <a
              href="#"
              className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">

                Customers
              </a>
              <a
              href="#"
              className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">

                Resources
              </a>
              <a
              href="#"
              className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">

                Company
              </a>
              <button
              onClick={() => {
                onViewModeChange(viewMode === 'admin' ? 'public' : 'admin');
                setMobileMenuOpen(false);
              }}
              className="bg-secondary text-secondary-foreground px-4 py-2 rounded-lg font-medium text-sm hover:opacity-90 transition-opacity text-left">

                {viewMode === 'admin' ? 'View Public' : 'Admin Panel'}
              </button>
            </div>
          </div>
        }
      </div>
    </nav>);

}